import localeText from "../../../../../locale";
import { localeISO } from "../../../../../utilities/localeIso";

const formatNumber = (value) => (value ?? 0).toLocaleString(localeISO);

// Parte de um todo com três status: uma barra 100% empilhada + legenda com os valores
const ProductsStatusChart = ({ data, loading }) => {
  const segments = [
    {
      key: "published",
      label: localeText("productsPublished"),
      value: data?.amountPublishedProducts || 0,
      color: "var(--admin-series-1)",
    },
    {
      key: "unpublished",
      label: localeText("productsNotPublished"),
      value: data?.amountUnpublishedProducts || 0,
      color: "var(--admin-series-2)",
    },
    {
      key: "archived",
      label: localeText("archivedProducts"),
      value: data?.amountArchievedProducts || 0,
      color: "var(--admin-series-3)",
    },
  ];

  const total = segments.reduce((sum, segment) => sum + segment.value, 0);
  const shareOf = (value) => (total ? Math.round((value / total) * 100) : 0);

  return (
    <section className="admin-home-card">
      <header className="admin-home-card__header">
        <div>
          <h2 className="admin-home-card__title">{localeText("productsOfSystem")}</h2>
          <p className="admin-home-card__subtitle">
            {loading ? "…" : `${formatNumber(total)} ${localeText("adminHomeTotalProducts")}`}
          </p>
        </div>
      </header>

      <div className="admin-home-stack" aria-hidden="true">
        {!loading &&
          total > 0 &&
          segments
            .filter((segment) => segment.value > 0)
            .map((segment) => (
              <span
                key={segment.key}
                className="admin-home-stack__segment"
                style={{ flexGrow: segment.value, backgroundColor: segment.color }}
                title={`${segment.label}: ${formatNumber(segment.value)} (${shareOf(segment.value)}%)`}
              />
            ))}
      </div>

      <ul className="admin-home-legend">
        {segments.map((segment) => (
          <li key={segment.key} className="admin-home-legend__row">
            <span className="admin-home-legend__swatch" style={{ backgroundColor: segment.color }} />
            <span className="admin-home-legend__label">{segment.label}</span>
            <span className="admin-home-legend__value">
              {loading ? "" : formatNumber(segment.value)}
            </span>
            <span className="admin-home-legend__share">
              {loading ? "" : `${shareOf(segment.value)}%`}
            </span>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default ProductsStatusChart;
